import loadable from "@loadable/component";

export const UnderwriterLegalAgreementsPage = loadable(
  () => import("./UnderwriterLegalAgreementsPage"),
  {
    resolveComponent: mod => mod.UnderwriterLegalAgreementsPage,
  },
);

export * from "./types";
